import React from "react";
import { MessageCircle } from "lucide-react";
import { waNumber } from "../lib/utils";

export default function WhatsAppFab({ number, message = "Hi Little Oak, I have a question" }) {
  const n = waNumber(number);
  if (!n) return null;
  return (
    <a href={`https://wa.me/${n}?text=${encodeURIComponent(message)}`} target="_blank" rel="noreferrer"
       aria-label="Chat with us on WhatsApp" data-testid="whatsapp-fab"
       className="fixed bottom-4 right-4 z-30 bg-[#25D366] text-white rounded-full w-12 h-12 grid place-items-center shadow-xl hover:scale-105 transition-transform">
      <MessageCircle size={22} />
    </a>
  );
}
